import { FC, useContext, useEffect, useRef, useState } from "react";

import FooterText from "../../components/footerText";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";
import { DocumentAPIError, DocumentAPIResponse } from "./types";


const HubUploadPEF: FC = (): JSX.Element => {
 
  const ref = useRef<HTMLInputElement>(null);
  const [uploadFile, changeUploadFile] = useState<FileList | null>(null);
  const { showToast } = useContext(ToastContext);
  const { error: uploadPEFFileError, data: uploadPEFFileResponse, mutate: uploadPEFDocument } =
    useFetch<DocumentAPIResponse>(APIEndpoints.UPLOAD_PEF);

  useEffect(() => {
    if (uploadPEFFileError) {
      changeUploadFile(null);
      reset()
      const {error } = uploadPEFFileError as unknown as DocumentAPIError; 
      showToast([error || `File Not Uploaded.Please try again`], ToastTypes.ERROR)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadPEFFileError]);

  useEffect(() => {
    if (uploadPEFFileResponse) {
      changeUploadFile(null);
      reset();
      const { message } = uploadPEFFileResponse;
      showToast([message], ToastTypes.SUCCESS);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadPEFFileResponse]);

  const uploadForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (uploadFile) {
      if (uploadFile[0].type === 'application/pdf') {
        const formData = new FormData();
        formData.append('fax_document', uploadFile[0]);
        uploadPEFDocument(formData);
      } else {
        showToast([`Please Select PDF format only.`], ToastTypes.WARNING);
      }
    } else {
      showToast([`Please Select PDF File first`], ToastTypes.WARNING);
    }
  };

  const reset = () => {
    if(ref && ref.current){
      ref.current.value = ""
    }
  };

  const clearDataAndForm = () => {
    changeUploadFile(null);
    reset();
  };

  return (
    <div className="container-fluid login-sec pt-5 p-0 overflow-auto d-flex flex-column flex-fill">
      <div className="container flex-fill d-flex flex-column">
        <div className="row flex-fill">
          <div className="col-lg-7 col-md-6 col-12"></div>
          <div className="col-lg-5 col-md-6 col-12">
            <div className="card p-0">
              <div className="card-header">
                <h1 className="mb-0">Upload Prescription Start Form</h1>
              </div>
              <div className="card-body">
                <form onSubmit={uploadForm}>
                  <p className="form-text">
                    Please select and upload a completed Prescription Start Form to have our team transcribe it and begin
                    the benefits investigation process.
                  </p>

                  <div className="input-group mb-3">
                    <input type="file" className="form-control" id="fileUpload"
                           onChange={(e) => changeUploadFile(e.target.files)} ref={ref}/>
                    {uploadFile ? (
                        <button className="btn btn-outline-secondary" disabled={!uploadFile} type="button" id="fileUpload"
                                onClick={clearDataAndForm}
                        >
                          Clear
                        </button>
                    ) : null}
                    <button className="btn btn-primary" disabled={!uploadFile} type="submit" id="fileUpload">Upload
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center pt-3 pb-4">

          <FooterText footerType="white"/>
        </div>
      </div>
    </div>
  );
};

export default HubUploadPEF;
